import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./ActivityFrequencySelectorStyles";
import { activityActions } from "../_actions";

export default class ActivityFrequencySelector extends Component {
  render() {
    const {
      activity: { activityFrequency }
    } = this.props;
    return (
      <div className={css(styles.selectorWrapper)}>
        <span
          className={css(styles.selectorPanel)}
          onClick={() =>
            activityFrequency !== "timeline"
              ? this.props.dispatch(
                  activityActions.setActivityFrequency("timeline")
                )
              : null
          }
        >
          <p
            className={css(
              styles.selector,
              activityFrequency === "timeline" && styles.selected
            )}
          >
            Timeline
          </p>
        </span>
        <span
          className={css(styles.selectorPanel)}
          onClick={() =>
            activityFrequency !== "day"
              ? this.props.dispatch(activityActions.setActivityFrequency("day"))
              : null
          }
        >
          <p
            className={css(
              styles.selector,
              activityFrequency === "day" && styles.selected
            )}
          >
            Daily
          </p>
        </span>
        <span
          className={css(styles.selectorPanel)}
          onClick={() =>
            activityFrequency !== "week"
              ? this.props.dispatch(
                  activityActions.setActivityFrequency("week")
                )
              : null
          }
        >
          <p
            className={css(
              styles.selector,
              activityFrequency === "week" && styles.selected
            )}
          >
            Weekly
          </p>
        </span>
      </div>
    );
  }
}
